export default "__VITE_ASSET__OolNOx4z__"